<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title" style="position: relative;">抽奖纪录
        </div>
        <div class="user_content_blcok_line"></div>

        <div class="admin_table_main">
      <el-table ref="homeSubjectTable"
                class="table"
                stripe
                :data="list"
                @selection-change="handleSelectionChange"
                v-loading="listLoading" border>
        <el-table-column label="序号" width="80" align="center" sortable prop="id" fixed="left">
          <template slot-scope="scope">{{scope.row.id}}</template>
        </el-table-column>
        <el-table-column label="奖项" width="100" align="center" >
          <template slot-scope="scope">{{scope.row.award_name}}</template>
        </el-table-column>
        <el-table-column label="抽奖名称" align="center">
          <template slot-scope="scope">{{scope.row.award}}</template>
        </el-table-column>
        <!-- <el-table-column label="中奖用户" align="center" sortable prop="name">
          <template slot-scope="scope">{{scope.row.name}}</template>
        </el-table-column> -->
        <el-table-column label="抽奖时间" align="center" sortable prop="winning_time" width="160">
          <template slot-scope="scope">
            <p><el-tag size="mini">{{scope.row.winning_time | formatDateTime}}</el-tag></p>
            <p v-show="scope.row.sendtime"><el-tag size="mini" type="success">发货时间:{{scope.row.sendtime | formatTime}}</el-tag></p>
            </template>
        </el-table-column>
        <el-table-column label="物流信息" align="center" sortable prop="expressno" width="160">
          <template slot-scope="scope">
            <p v-if="scope.row.company"><el-tag size="mini">快递公司:{{scope.row.company}}</el-tag></p>
            <p v-if="scope.row.expressno"><el-tag size="mini" type="success" >物流单号:{{scope.row.expressno}}</el-tag></p>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
           <p v-if="scope.row.expressno"><el-button type="primary" size="mini"
                       @click="showLogisticsDialog(scope.$index, scope.row)">查看物流
           </el-button></p>
          </template>
        </el-table-column>

      </el-table>
                <div class="home_fy_block" style="margin-top:40px;" >
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total" :page-size="pageSize" :current-page="pageNum"></el-pagination>
                </div>
            </div>

    <el-dialog title="订单跟踪"
               :visible.sync="logisticsDialogVisible"
               width="40%">
    <div class="table-container" style="height:400px;">
                    <el-scrollbar style="height:100%; overflow-x: hidden">
                      <el-timeline :reverse="reverse" style="padding:10px;">
                        <el-timeline-item
                          v-for="(item, index) in explist"
                          :key="index"
                          :timestamp="item.time">
                          {{item.title}}
                        </el-timeline-item>
                      </el-timeline>
                    </el-scrollbar>


    </div>

    </el-dialog>

    </div>
</template>

<script>
import {formatDate} from '@/utils/date';
export default {
    components: {},
    props: {},
    data() {
      return {
          list:[],
          total:0, // 总条数
          pageSize:10,
          pageNum:1,
          title:'抽奖记录',
          logisticsDialogVisible:false,
          expOrderId:null,
          explist:[],
      };
    },
    watch: {
        
    },
    filters: {
      formatDateTime(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      }, 
    },
    computed: {},
    methods: {
        // handleSelectionChange:function(e){
        //     let ids = [];
        //     e.forEach(v => {
        //         ids.push(v.id);
        //     });
        //     this.select_id = ids.join(',');
        // },
        get_luckDraw_list:function(){
            this.$get(this.$api.awardWinUserByCompanyId,{pageSize:this.pageSize,pageNum:this.pageNum,platId:this.$platId}).then(res=>{
                this.pageSize = res.data.pageSize;
                this.total = res.data.total;
                this.pageNum = res.data.pageNum;
                this.list = res.data.list;
            })

        },
        current_change:function(e){
            this.pageNum = e;
            this.get_luckDraw_list();
            this.$scrollTo();
        },

       //物流跟踪
       showLogisticsDialog(index,row){
        this.expOrderId = row.expressno;
        this.$get(this.$api.exterfaceInvoke + this.expOrderId).then(res => {
          if(res.code == 200){
            if(res.data != null){
              this.logisticsDialogVisible=true;
              this.explist = res.data;
            }else{
              this.$message.error('暂无物流信息');
              this.logisticsDialogVisible = false;
            }
          }
          });
       },

    },
    created() {
        this.get_luckDraw_list();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.red{
    color:#409EFF;
}
.green{
    color:#42b983;
}
.text{
  text-align: left;
}
.text p{
  line-height: 35px;
  margin: 0px;
}
.text p:first-child{
  border-top: none !important;
}
.text p:nth-child(odd){
  border-top: 1px dashed #dfdfdf;
}
.after_sale{
  padding: 0 20px;
}
</style>